<template>
  <Drawer
    :id="drawerId"
    :title="title"
    height="90%"
    bottom
    class="rounded-t-xl"
  >
    <div class="px-4 pt-4">
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row>
          <v-col
            v-if="showUnits"
            cols="12"
          >
            <v-menu absolute>
              <template #activator="{ on: { click }, attrs }">
                <div
                  v-bind="attrs"
                  @click="click"
                >
                  Units:
                  <span class="font-weight-bold">
                    {{ units.filter((x) => x.id == unitId).map((x) => x.name)[0] }}
                  </span>
                  <v-icon>mdi-menu-down</v-icon>
                </div>
              </template>
              <v-list>
                <v-list-item
                  v-for="(unit, i) in units"
                  :key="i"
                  @click="unitId = unit.id"
                >
                  <v-list-item-title>{{ unit.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-radio-group
              v-model="coreProductId"
              :rules="[$rules.required]"
              class="py-0 my-0"
              hide-details="auto"
            >
              <mcs-card
                v-for="(item, i) in filtered_core_products"
                :key="i"
                paddingClass="pa-4"
                :class="i < filtered_core_products.length - 1 ? 'mb-4' : ''"
              >
                <div class="d-flex">
                  <v-radio
                    class="my-auto"
                    color="black"
                    :label="item.name"
                    :value="item.id"
                    hide-details
                  >
                  </v-radio>
                  <mcs-chip
                    v-if="i == 0"
                    color="primaryLight"
                    class="ml-auto my-auto"
                  >
                    Most Popular
                  </mcs-chip>
                </div>
              </mcs-card>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <Portal :to="`drawerAppend-${drawerId}`">
      <div class="pa-4">
        <div
          v-if="detail.length"
          class="mb-4"
        >
          <div class="font-weight-bold mb-1">Selection details:</div>
          <mcs-icon-list :items="detail"></mcs-icon-list>
        </div>
        <mcs-btn
          large
          color="black"
          block
          :loading="saving"
          @click="save"
        >
          Start Designing
        </mcs-btn>
      </div>
    </Portal>
  </Drawer>
</template>

<script>
import Drawer from '@/components/layout/Drawer';
import { DRAWERS, ENUMS } from '@/utils/constants';
import collections from '@/utils/mixins/collections';
import { orderBy, uniq } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  components: { Drawer },
  mixins: [collections],
  props: {},
  data: () => ({
    saving: false,
    valid: false,
    drawerId: DRAWERS.BLANK_CANVAS_PRESET,
    isTemplate: false,
    categoryId: null,
    coreProductId: null,
    unitId: null
  }),
  computed: {
    title() {
      return `${this.category.name} Sizes`;
    },
    showUnits() {
      if (this.core_products.length) {
        const hasMultipleUnits = uniq(this.core_products.map((x) => x.unitId)).length > 1;
        if (hasMultipleUnits) {
          return true;
        }
      }
      return false;
    },
    core_products() {
      return this.core_products_func(this.categoryId);
    },
    filtered_core_products() {
      let list = this.core_products;
      if (this.unitId && this.showUnits) {
        list = list.filter((x) => x.unitId === this.unitId);
      }
      return orderBy(list, ['isCategoryDefault', 'width', 'height'], ['desc', 'asc', 'asc']);
    },
    category() {
      return this.categories.find((x) => x.id === this.categoryId) || {};
    },
    core_product() {
      return this.core_products.find((x) => x.id === this.coreProductId) || {};
    },
    detail() {
      if (!this.core_product.id) {
        return [];
      }
      const list = [
        {
          icon: 'mdi-download',
          text: 'Downloading options are <span class="font-weight-bold">available</span>'
        },
        {
          icon: 'mdi-cart',
          text: `Printing services are <span class="font-weight-bold ${
            this.core_product.printable ? '' : 'error--text'
          }">${this.core_product.printable ? '' : 'not '}available</span>`
        },
        {
          icon: 'mdi-rocket-launch',
          text: `Direct mail services are <span class="font-weight-bold ${
            this.core_product.mailable ? '' : 'error--text'
          }">${this.core_product.mailable ? '' : 'not '}available</span>`,
          hide: !this.category.hasDirectMail
        },
        {
          icon: 'mdi-currency-usd',
          text: `Starting print price is <span class="font-weight-bold">${this.$options.filters.currencyShort(
            this.core_product.startingPrice
          )}</span>`,
          hide: !this.core_product.printable
        }
      ];

      return list.filter((x) => !x.hide);
    },
    ...mapGetters({
      folders: 'admin/collections/all_folders',
      initialData: 'drawers/data',
      top_drawer: 'drawers/topDrawer',
      drawerOpenedAt: 'drawers/lastOpenedAt',
      categories: 'templates/categories',
      core_products_func: 'templates/core_products',
      units: 'lookups/units',
      prefersMetric: 'user/prefersMetric'
    })
  },
  watch: {
    drawerOpenedAt(val, oldVal) {
      if (this.drawerId === this.top_drawer?.id) {
        this.unitId = this.prefersMetric ? ENUMS.UNITS.MILLIMETERS : ENUMS.UNITS.INCHES;
        this.saving = false;
        const initial = this.initialData(this.drawerId) || {};
        this.isTemplate = initial.isTemplate;
        this.categoryId = initial.categoryId || null;
        this.$nextTick(() => {
          this.coreProductId = this.filtered_core_products[0].id;
        });
      }
    },
    categoryId(val, oldVal) {
      if (val !== oldVal) {
        this.coreProductId = null;
      }
    }
  },
  methods: {
    cancel() {
      this.$store.commit('drawers/CLOSE_DRAWER', this.drawerId);
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$api
          .post('collections/getTemplateEditorUrl', {
            isCustom: false,
            collectionId: this.isTemplate ? this.collectionId : null,
            folderId: this.parentId,
            coreProductId: this.coreProductId
          })
          .then((response) => {
            window.open(response.data.url, '_blank');
            this.cancel();
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
